// src/pages/ProductPage.tsx — Site officiel Vanessa
import { Link, useParams } from 'react-router-dom';
import { Section, Grid, FeatureCard, Steps, CtaBand, PageHeader } from '@/components/site/blocks';
import { getProduct, PRODUCTS } from '@/content/products';
import { APP_OPEN_URL } from '@/config/site';
import { buttonClasses } from '@/components/ui/button';
import NotFoundPage from './NotFoundPage';

export default function ProductPage() {
    const { slug } = useParams<{ slug: string }>();
    const product = getProduct(slug);
    if (!product) return <NotFoundPage />;

    const others = PRODUCTS.filter((p) => p.slug !== product.slug);

    return (
        <>
            <PageHeader eyebrow={product.status || 'Produits'} title={product.name} intro={`${product.tagline} ${product.intro}`}>
                {!product.status && <a href={APP_OPEN_URL} className={buttonClasses('primary', 'lg')}>Ouvrir l’application</a>}
                <Link to="/produits" className={buttonClasses('secondary', 'lg')}>Tous les produits</Link>
            </PageHeader>

            <Section title="Ce que vous pouvez faire">
                <Grid cols={3}>
                    {product.features.map((f) => (
                        <FeatureCard key={f.title} icon={f.icon} title={f.title}>{f.text}</FeatureCard>
                    ))}
                </Grid>
            </Section>

            {product.steps && (
                <Section tone="sand" title={product.stepsTitle}>
                    <div className="max-w-2xl"><Steps items={product.steps} /></div>
                </Section>
            )}

            {product.note && (
                <Section>
                    <p className="max-w-2xl rounded-2xl border border-brand bg-brand-tint p-5 text-base leading-relaxed text-ink">
                        {product.note}
                    </p>
                </Section>
            )}

            <Section title="Découvrir aussi">
                <div className="flex flex-wrap gap-3">
                    {others.map((p) => (
                        <Link key={p.slug} to={`/produits/${p.slug}`} className={buttonClasses('secondary', 'md')}>
                            {p.name}
                        </Link>
                    ))}
                </div>
            </Section>

            <CtaBand
                title="Prêt à essayer ?"
                primary={{ label: 'Ouvrir l’application', href: APP_OPEN_URL }}
                secondary={{ label: 'Poser une question', to: '/contact' }}
            />
        </>
    );
}
